// extracted by mini-css-extract-plugin
module.exports = {"MainContainer":"Main_MainContainer__1tYpl"};